import { Avatar, Box, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, InputLabel, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import MUIButton from "../../reusable_components/components/MUIButton"
import { useClientApproveAndRejectMutation, useGetGridDatasMutation, useGetReferralClientMailDescMutation, useReferralListMutation, useSendEmailReferralClientMutation } from "../../redux/clients/clients.api"
import { Link, useNavigate } from "react-router-dom"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import { TableLoader } from "../../reusable_components/components/TableLoader"
import AddIcon from '@mui/icons-material/Add';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useGetClientDropdownQuery } from "../../redux/jobpostings/jobpostings.api"
import dayjs from "dayjs"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DoneIcon from '@mui/icons-material/Done';
import SearchIconLg from "../../assets/Icons/SearchIcon"
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker"
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import EditIcon from "../../assets/Icons/EditIcon";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EmailIcon from '@mui/icons-material/Email';
import ReactQuill from "react-quill"
import Loader from "../../reusable_components/components/Loader";
import { useSelector } from "react-redux"


const ClientReferrals = ({ search }) => {

    const navigate = useNavigate()
    const [client, setClient] = useState("")
    const [selectedStatus, setSelectedStatus] = useState("")
    const [selectedStatusName, setSelectedStatusName] = useState("")
    const [filterByPhone, setFilterByPhone] = useState("")
    const [filterByEmail, setFilterByEmail] = useState("")
    const [filterByCreatedDate, setFilterByCreatedDate] = useState(null)
    const [filterByToDate, setFilterByToDate] = useState(null)
    const [filterByAddress, setFilterByAddress] = useState("")
    const [filterByCity, setFilterByCity] = useState("")
    const [searchKeyword, setSearchKeyword] = useState("")
    const [clientTableDatas, setClientTableDatas] = useState([])
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [sortingColumn, setSortingColumn] = useState("created_date")
    const [sortingDirection, setSortingDirection] = useState("DESC")
    const [open, setOpen] = useState(false)
    const [triggerAPI, setTriggerAPI] = useState(false)
    const [showClearFilter, setShowClearFilter] = useState(false)
    const [reason, setReason] = useState("")
    const [openReject, setOpenReject] = useState(false)
    const [isReason, setIsReason] = useState("")
    const [clientId, setClientId] = useState();
    const [openMailDialog, setOpenMailDialog] = useState(false)
    const [mailBodycontent, setMailBodycontent] = useState("");

    const [mailTo, setMailTo] = useState("")
    const [mailSubject, setMailSubject] = useState("")
    const [showLoader, setShowLoader] = useState(false)
    const [textBody, setTextBody] = useState("")


    // Pagination
    const [page, setPage] = useState(1)
    const [totalDataCount, setTotalDataCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const { Snackbar } = useContext(SnackbarContext)

    const [getTableDatas] = useGetGridDatasMutation()
    const { data: getClientDropdownlist } = useGetClientDropdownQuery()

    const [referralList] = useReferralListMutation();
    const [clientApproveAndReject] = useClientApproveAndRejectMutation();
    const [getReferralClientMailDesc] = useGetReferralClientMailDescMutation();
    const [sendEmailReferralClient] = useSendEmailReferralClientMutation()

    const { Profile } = useSelector((state) => state.common)
    const adminName = Profile?.profile?.firstName
    const adminLastName = Profile?.profile?.lastName
    const adminEmail = Profile?.profile?.emailId

    const handleMailDialogClose = () => {
        setOpenMailDialog(false)
        setMailBodycontent("")
        setMailTo("")
        setMailSubject("")
    }

    const handleMailToChange = (e) => {
        const value = e.target.value
        setMailTo(value)
    }

    const handleMailSubjectChange = (e) => {
        const value = e.target.value
        setMailSubject(value)
    }

    const handleBodyContentChange = (value) => {
        setMailBodycontent(value)
        setDummyMail(value)
    }

    const handleOpen = () => {
        if (chips.length === 0) {
            setClient("")
            setFilterByPhone("")
            setSelectedStatus("")
            setFilterByEmail("")
            setFilterByCreatedDate(null)
            setFilterByToDate(null)
            setFilterByAddress("")
            setFilterByCity("")
            setSelectedStatusName("")
            setOpen(true)
        } else {
            setOpen(true)
        }
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleReason = (e) => {
        setReason(e.target.value)

        if (reason === '') {
            setIsReason("Reason for Rejection is Required")
        }
    }

    const handleClientName = (e) => {
        const value = e.target.value
        setClient(value)
    }

    const handleFilterByPhone = (e) => {
        const value = e.target.value
        setFilterByPhone(value)
    }

    const handleFilterByEmail = (e) => {
        const value = e.target.value
        setFilterByEmail(value)
    }

    const handleFilterByCreatedDate = (value) => {
        setFilterByCreatedDate(value)

        if (filterByToDate && filterByToDate <= value) {
            setFilterByToDate(null)
        }
    }

    const handleFilterByToDate = (value) => {
        setFilterByToDate(value)
    }

    const getNextDay = (fromDate) => {
        if (!fromDate) {
            return null
        }

        return dayjs(fromDate)?.add(1, 'day')
    }

    const handleFilterByAddress = (e) => {
        const value = e.target.value
        setFilterByAddress(value)
    }

    const handleFilterByCity = (e) => {
        const value = e.target.value
        setFilterByCity(value)
    }

    const clientStatus = [
        {
            statusName: 'Approved',
            statusId: 1
        },
        {
            statusName: 'Rejected',
            statusId: 2
        },
        {
            statusName: 'Pending',
            statusId: 3
        }
    ]

    const handleStatusChange = (e) => {
        const value = e.target.value
        setSelectedStatus(value)

        const statusName = clientStatus?.find((id) => id?.statusId === value)
        setSelectedStatusName(statusName?.statusName)
    }

    const handleSearchKeywordChange = (e) => {
        const value = e.target.value
        setSearchKeyword(value)
    }

    const handleSort = (columnName) => {
        if (sortingColumn === columnName) {
            setSortingDirection((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'))
            setTriggerAPI(true)
        } else {
            setSortingColumn(columnName)
            setSortingDirection('ASC')
        }
    }

    const handleClearFilter = () => {
        setClient("")
        setFilterByPhone("")
        setSelectedStatus("")
        setFilterByEmail("")
        setFilterByCreatedDate(null)
        setFilterByToDate(null)
        setFilterByAddress("")
        setFilterByCity("")
        setSelectedStatusName("")
        setTriggerAPI(true)
        setShowClearFilter(false)
    }

    // Pagination Functionalities
    const handleChangePage = (e, newPage) => {
        setPage(newPage)
        setTriggerAPI(true)
    }

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    }

    const formats = [
        'header', 'font', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'color', 'background',
        'list', 'bullet', 'indent', 'align', 'script', 'link', 'image', 'size',
    ]

    const toolBarOptions = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, false] }, { 'font': [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean'],
            // ['undo', 'redo'],
        ],
    }

    const formatDate = (date = new Date()) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const handleEditClientNav = (item) => {
        navigate(`/referrals/client-view`, {
            state: {
                clientName: item?.clientName, clientId: item?.ClientId, isReferrals: true, isReferralClient: item?.isReferral
            }
        }
        )
    }

    const getGridDatas = async () => {
        try {
            const payload = {
                clientName: client || search,
                address: filterByAddress,
                email: filterByEmail,
                status: selectedStatus,
                city: filterByCity,
                phone: filterByPhone,
                fromDate: filterByCreatedDate ? dayjs(filterByCreatedDate).format('YYYY-MM-DD') : '',
                toDate: filterByToDate ? dayjs(filterByToDate).format('YYYY-MM-DD') : '',
                sortingDirection: sortingDirection,
                sortingColumn: sortingColumn,
                page: (page - 1),
                size: rowsPerPage,
            }
            setShowTableLoader(true)
            const response = await referralList(payload).unwrap()
            setShowTableLoader(false)
            setClientTableDatas(response?.response?.data)
            setTotalDataCount(response?.response?.Count)

        } catch (err) {
            Snackbar("Network Error", 'error')
            setShowTableLoader(false)
        }
    }

    useEffect(() => {
        getGridDatas()
    }, [search])

    const [chips, setChips] = useState([])

    const letsFilterDatas = () => {
        const updatedChip = ([
            {
                label: client,
                onDelete: () => {
                    setClient('')
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== client))
                }
            },
            {
                label: filterByPhone,
                onDelete: () => {
                    setFilterByPhone('')
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== filterByPhone))
                }
            },
            {
                label: filterByEmail,
                onDelete: () => {
                    setFilterByEmail('')
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== filterByEmail))

                }
            },
            {
                label: filterByAddress,
                onDelete: () => {
                    setFilterByAddress('')
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== filterByAddress))

                }
            },
            {
                label: filterByCity,
                onDelete: () => {
                    setFilterByCity('')
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== filterByCity))

                }
            },
            {
                label: selectedStatusName,
                onDelete: () => {
                    setSelectedStatusName("")
                    setSelectedStatus("")
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== selectedStatusName))

                }
            },
            filterByCreatedDate && {
                label: dayjs(filterByCreatedDate)?.format('DD-MM-YYYY'),
                onDelete: () => {
                    setFilterByCreatedDate(null)
                    setFilterByToDate(null)
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== dayjs(filterByCreatedDate)?.format('DD-MM-YYYY')))

                }
            },
            filterByToDate && {
                label: dayjs(filterByToDate)?.format('DD-MM-YYYY'),
                onDelete: () => {
                    setFilterByToDate(null)
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== dayjs(filterByToDate)?.format('DD-MM-YYYY')))

                }
            }
        ]).filter(Boolean)

        setChips(updatedChip)
        setTriggerAPI(true)
        setShowClearFilter(true)
    }

    useEffect(() => {
        if (triggerAPI) {
            getGridDatas()
            handleClose()
            setTriggerAPI(false)
        }
    }, [referralList, client, selectedStatus, filterByPhone, filterByEmail, filterByCreatedDate, filterByAddress, filterByCity, page, rowsPerPage, sortingDirection, triggerAPI])

    const filteredTableDatas = clientTableDatas?.filter((item) => {
        return (
            (item?.clientName?.toLowerCase()?.includes(searchKeyword?.toLowerCase()))
        )
    })

    useEffect(() => {
        if (chips?.every((name) => !name?.label)) {
            setShowClearFilter(false)
        }
    }, [triggerAPI])

    const statusOptions = [
        {
            id: 1,
            label: 'Approved'
        },
        {
            id: 2,
            label: 'Rejected'
        },
        {
            id: 3,
            label: 'Pending'
        },
    ]

    const handleEditScreenNav = (item) => {
        // navigate(`/referrals/client-edit/${item?.ClientId}`)
        navigate(`/referrals/client-edit/${item?.ClientId}`, {
            state: {
                isReferrals: true, isReferralClient: item?.isReferral
            }
        })
    }

    const handleApproved = async (item) => {
        try {
            const payload = {
                clientId: item?.ClientId,
                gmId: 1,
                feedBack: null,
            }
            const response = await clientApproveAndReject(payload).unwrap();
            if (response?.status === 200) {
                Snackbar(response?.response, 'success')
            }
            else if (response?.data?.error_code === "67") {
                Snackbar(response?.data?.error_message, 'error')
            }
            getGridDatas()

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const handleRejectedOpen = (item) => {
        setClientId(item?.ClientId)
        setOpenReject(true)
    }

    const handleCloseReject = () => {
        setOpenReject(false)
        setIsReason("")
        setReason("")
    }

    const handleRejected = async () => {
        try {
            if (reason === "" || reason === null) {
                return setIsReason("Reason for Rejection is Required")
            }
            const payload = {
                clientId: clientId,
                gmId: 2,
                feedBack: reason
            }

            const response = await clientApproveAndReject(payload).unwrap();
            Snackbar(response?.response, 'success')
            getGridDatas()
            handleCloseReject()
        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }


    const [dummyMail, setDummyMail] = useState(`<p>Dear Sir/Madam,</p><br>
        <p>I hope you're doing well. Thank you for sharing the client referral with us.</p>
        <br>
        <p> We have reviewed the details and would like to schedule a discussion to explore the next steps. Please let us know a convenient time for a brief conversation at your earliest convenience. </p>
        <br>
        <p>Looking forward to collaborating further.</p>
        <br>
        <p><strong>Thanks and Regards,</strong></p>
        <p><a href="mailto:${adminEmail}" style="color: blue;">${adminName} ${adminLastName}</a><br>
        <p><a href="#" style="color: blue;">Open Recruiter Team</a></p>
        <p>For any queries, reach out to our admin team at 
        <a href="mailto:helpdesk@3edge.in" style="color: blue;">helpdesk@3edge.in</a>.</p>`)

    const [BAname, setBAname] = useState("")

    const getClientMail = async (item) => {
        setBAname(item?.sourcedUserName)
        setMailTo(item?.sourcedUserEmail)
        setOpenMailDialog(true)
        try {
            const payload = {
                sourcedUserEmail: item?.sourcedUserEmail,
                customMailText: "I hope you doing good"
            }

            const response = await getReferralClientMailDesc(payload).unwrap()
            // setMailBodycontent(response?.response?.htmlBody)
            setMailBodycontent(`<p>Dear Sir/Madam,</p><br>
                                <p>I hope you're doing well. Thank you for sharing the client referral with us.</p>
                                <br>
                                <p> We have reviewed the details and would like to schedule a discussion to explore the next steps. Please let us know a convenient time for a brief conversation at your earliest convenience. </p>
                                <br>
                                <p>Looking forward to collaborating further.</p>
                                <br>
                                <p><strong>Thanks and Regards,</strong></p>
                                <p><a href="mailto:${adminEmail}" style="color: blue;">${adminName} ${adminLastName}</a><br>
                                <p><a href="#" style="color: blue;">Open Recruiter Team</a></p>
                                <p>For any queries, reach out to our admin team at 
                                <a href="mailto:helpdesk@3edge.in" style="color: blue;">helpdesk@3edge.in</a>.</p>`)
            setTextBody(response?.response?.textBody)
            setMailSubject(response?.response?.Subject)
            setMailTo(response?.response?.To)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    const handleSendEmailToRecruiter = async () => {
        let formattedMailBody = mailBodycontent.replace(/<p>&nbsp;<\/p>/g, "<br />").replace(/<p><\/p>/g, "<br />");

        try {
            const payload = {
                htmlBody: `<p>Dear Sir/Madam,<br><br>
                                I hope you're doing well. Thank you for sharing the client referral with us.<br><br>
                                
                                We have reviewed the details and would like to schedule a discussion to explore the next steps. Please let us know a convenient time for a brief conversation at your earliest convenience. <br><br>
                                
                                Looking forward to collaborating further.<br><br>
                                
                                <p><strong>Thanks and Regards,</strong><br>
                                <a href="mailto:${adminEmail}" style="color: blue;">${adminName} ${adminLastName}</a><br>
                                <a href="#" style="color: blue;">Open Recruiter Team</a><br>
                                For any queries, reach out to our admin team at 
                                <a href="mailto:helpdesk@3edge.in" style="color: blue;">helpdesk@3edge.in</a></p>`,
                // htmlBody:dummyMail,
                textBody: textBody,
                subject: mailSubject,
                toMails: mailTo,
            }
            setShowLoader(true)
            const response = await sendEmailReferralClient(payload).unwrap()
            setShowLoader(false)

            if (response?.status === 200) {
                Snackbar("Mail Sent Sucessfully", 'success')
                handleMailDialogClose()
                setMailTo("")
            }
        } catch (err) {
            Snackbar("Network error", 'error')
            setShowLoader(false)
        }
    }


    return (
        <Box >
            {showLoader ? <Loader /> : ""}
            {/* Container 1 */}
            <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                {/* <Grid2 item container sx={{ display: 'flex', gap: '15px', marginTop: "15px" }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <Typography className="title">Client Referrals</Typography>
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <Box>
                                <TextField
                                    className="textfields"
                                    size="small"
                                    placeholder='Search'
                                    slotProps={{
                                        input: {
                                            startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                                        },
                                    }}
                                    value={searchKeyword}
                                    onChange={handleSearchKeywordChange}
                                />
                            </Box>

                            <MUIButton title='Add Clients' startIcon={<AddIcon sx={{ marginRight: '-5px' }} />} component={Link} to='/client-add' sx={{ backgroundColor: '#7F56D9', width: '120px' }} />
                        </div>
                    </div>
                </Grid2> */}

                {/* Table Container */}
                <Grid2 item container sx={{ marginTop: '20px' }}>
                    <Paper sx={{ width: '100%', overflow: 'hidden', border: '1px solid #E9EAEB' }} elevation={0}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={100} sx={{ padding: '8px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '14px' }}>
                                            <div>
                                                {showClearFilter && (
                                                    chips?.map((item, index) => (
                                                        item?.label && (
                                                            <Chip key={index} label={item?.label} variant="outlined" size='small' deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />} onDelete={item?.onDelete} className='Chip' />
                                                        )
                                                    ))
                                                )}
                                            </div>
                                            <div style={{ display: 'flex', gap: '14px' }}>
                                                <MUICancelButton title='More Filters' onClick={handleOpen} startIcon={<FilterListIcon sx={{ fontSize: '18px !important' }} />} sx={{ color: '#6941C6', fontWeight: 600, width: '130px' }} />
                                                {(client || filterByPhone || filterByEmail || filterByAddress || filterByCity || selectedStatus || filterByCreatedDate || filterByToDate) && showClearFilter && (
                                                    <MUICancelButton title='Clear Filter' onClick={handleClearFilter} sx={{ width: '100px' }} />
                                                )}
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="tableHeadersCell">
                                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                            onClick={() => handleSort("created_date")}
                                        >
                                            Name
                                            <UnfoldMoreIcon sx={{ fontSize: '17px' }} />
                                        </div>
                                    </TableCell>
                                    <TableCell className="tableHeadersCell"> Address </TableCell>
                                    <TableCell className="tableHeadersCell"> Phone </TableCell>
                                    <TableCell className='tableHeadersCell_2'>Sourced By</TableCell>
                                    <TableCell className='tableHeadersCell_2'>Permanent Reward</TableCell>
                                    <TableCell className='tableHeadersCell_2'>Contract Reward</TableCell>
                                    <TableCell className="tableHeadersCell"> Created Date </TableCell>
                                    <TableCell className="tableHeadersCell"> Status </TableCell>
                                    <TableCell className="tableHeadersCell"> Action </TableCell>
                                </TableRow>
                            </TableHead>

                            {!showTableLoader ? (
                                filteredTableDatas?.length > 0 ? (
                                    <TableBody>
                                        {filteredTableDatas?.map((item, index) => {
                                            const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                            const backgroundColor = colors[index % colors?.length]

                                            return (
                                                <TableRow key={index}
                                                    sx={{
                                                        backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                        '&:hover': { backgroundColor: '#f1f1f1' },
                                                    }}
                                                >
                                                    <TableCell className="tableBodyCell" onClick={() => handleEditClientNav(item)}><span style={{ color: '#53389E', cursor: 'pointer', fontWeight: 600 }}>{item.clientName}</span>
                                                        <br></br> <span style={{ color: '#535862' }}>{item.clientEmail ? item.clientEmail : 'NA'}</span></TableCell>
                                                    <TableCell className="tableBodyCell" sx={{ color: '#535862', width: '200px' }}>{item.clientAddress ? item.clientAddress : 'NA'} {item.state} {item.city}</TableCell>
                                                    <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{item.clientPhone || '-'}</TableCell>
                                                    <TableCell className='tableBodyCells'>
                                                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                                                            <Avatar alt={item?.firstName || "NA"} sx={{ width: '32px', height: '32px', backgroundColor: backgroundColor, fontSize: '14px' }}>{item?.sourcedUserName?.charAt(0)?.toUpperCase() || "?"}</Avatar>
                                                            <Typography className='tableBodyCells' sx={{ color: "#181D27" }}>{item?.sourcedUserName}<br></br><span style={{ color: '#535862' }}>{item?.sourcedUserEmail}</span></Typography>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell className='tableBodyCell' >
                                                        {/* {
                                                            !item?.clientRewardType ? "-" : item?.clientRewardType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                        }<br></br> */}
                                                        {
                                                            !item?.clientRewardType ? "-" : item?.clientRewardType === "FC" ?
                                                                (
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                        <Typography sx={{ fontSize: '12.5px' }}>
                                                                            {item?.clientRewardAmount}
                                                                        </Typography>
                                                                    </Box>
                                                                ) :
                                                                (
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                        <Typography sx={{ fontSize: '12.5px' }}>{item?.clientRewardPct}%</Typography>
                                                                    </Box>
                                                                )
                                                        }
                                                    </TableCell>
                                                    <TableCell className='tableBodyCell' >
                                                        {/* {
                                                            !item?.clientRewardType ? "-" : item?.clientRewardType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                        }<br></br> */}
                                                        {
                                                            !item?.contractRewardType ? "-" : item?.contractRewardType === "FC" ?
                                                                (
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                        <Typography sx={{ fontSize: '12.5px' }}>
                                                                            {item?.contractRewardAmount}
                                                                        </Typography>
                                                                    </Box>
                                                                ) :
                                                                (
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                        <Typography sx={{ fontSize: '12.5px' }}>{item?.contractRewardPct}%</Typography>
                                                                    </Box>
                                                                )
                                                        }
                                                    </TableCell>
                                                    <TableCell className="tableBodyCell" sx={{ width: "10%", color: '#535862' }}>{formatDate(item?.createdDate)}</TableCell>
                                                    <TableCell className="tableBodyCell"> <span className={`clientStatus-badge ${item?.clientStatusName?.toLowerCase()}`}>{item.clientStatusName}</span></TableCell>
                                                    <TableCell className="tableBodyCell" sx={{ minWidth: "120px" }} align="left">
                                                        {/* mail icon */}
                                                        <Tooltip
                                                            slotProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#0A0D12",
                                                                        borderRadius: '8px',
                                                                        padding: '8px 12px',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                    }
                                                                }
                                                            }} title={`Email to ${item?.sourcedUserName}`}>
                                                            <span>
                                                                <EmailIcon
                                                                    className="icons"
                                                                    sx={{
                                                                        fontSize: "17px",
                                                                        margin: "5px",

                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={(e) => getClientMail(item)}
                                                                />
                                                            </span>
                                                        </Tooltip>

                                                        {/* Approve Icon */}
                                                        <Tooltip
                                                            slotProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#0A0D12",
                                                                        borderRadius: '8px',
                                                                        padding: '8px 12px',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                    }
                                                                }
                                                            }} title={item?.clientRewardType === null || item?.contractRewardType === null || !item?.displayName || !item?.clientName || !item?.clientPhone || !item?.clientEmail || !item?.clientAddress || !item?.state || !item?.country || !item?.city || !item?.agreementStartDate || !item?.agreementEndDate ? !item?.clientStatusName !== "Rejected" ?
                                                                "Client approval is not possible because some required details are missing. Please complete all necessary client information before proceeding."
                                                                : "This client has already been rejected and therefore cannot be approved."
                                                                : item?.clientStatusName !== "Rejected" ? "Approve"
                                                                    : "This client has been rejected by the admin. Please go to the edit section to review and approve."}>
                                                            <span>
                                                                <DoneIcon
                                                                    sx={{
                                                                        fontSize: "17px",
                                                                        margin: "5px",
                                                                        color: "#1cbd09",
                                                                        cursor: item?.clientStatusName !== "Pending" || item?.clientRewardType === null || item?.contractRewardType === null || !item?.displayName || !item?.clientName || !item?.clientPhone || !item?.clientEmail || !item?.clientAddress || !item?.state || !item?.country || !item?.city || !item?.agreementStartDate || !item?.agreementEndDate ? "not-allowed" : "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                        item?.clientStatusName === "Pending" && item?.clientRewardType !== null && item?.contractRewardType !== null && item?.displayName && item?.clientName && item?.agreementStartDate && item?.agreementEndDate && item?.clientPhone && item?.clientEmail && item?.clientAddress && item?.state && item?.country && item?.city ? handleApproved(item) : null
                                                                    }
                                                                />
                                                            </span>
                                                        </Tooltip>

                                                        {/* Reject Icon */}
                                                        <Tooltip
                                                            slotProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#0A0D12",
                                                                        borderRadius: '8px',
                                                                        padding: '8px 12px',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                    }
                                                                }
                                                            }} title={item?.clientStatusName === "Rejected" ? "Already Rejected" : "Reject"}>
                                                            <span>
                                                                <CloseOutlinedIcon
                                                                    sx={{
                                                                        fontSize: "17px",
                                                                        margin: "5px",
                                                                        color: "#D92D20",
                                                                        cursor: item?.clientStatusName === "Rejected" ? "not-allowed" : "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                        item?.clientStatusName !== "Rejected" ? handleRejectedOpen(item) : null
                                                                    }
                                                                />
                                                            </span>
                                                        </Tooltip>

                                                        {/* Edit Client Icon (Always Visible) */}
                                                        <Tooltip
                                                            title="Edit Client"
                                                            slotProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#0A0D12",
                                                                        borderRadius: '8px',
                                                                        padding: '8px 12px',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <div style={{ display: "inline-block" }}>
                                                                <EditIcon stroke={"#A4A7AE"} className="icons" onClick={() => handleEditScreenNav(item)} />
                                                            </div>
                                                        </Tooltip>
                                                    </TableCell>



                                                </TableRow>
                                            )
                                        }

                                        )}
                                    </TableBody>
                                ) : (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography className="emptydatas">No Data Found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8}>
                                        <Box className='tableloader'>
                                            <TableLoader />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                            {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                                <TableRow>
                                    <TableCell colSpan={100}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MUICancelButton
                                                title='Previous'
                                                startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                onClick={() => handleChangePage(null, page - 1)}
                                                disabled={page === 1}
                                                sx={{ height: '36px' }}
                                            />

                                            <Pagination
                                                page={page}
                                                onChange={handleChangePage}
                                                count={Math.ceil(totalDataCount / rowsPerPage)}
                                                siblingCount={1}
                                                boundaryCount={1}
                                                shape="rounded"
                                                hideNextButton
                                                hidePrevButton
                                            />

                                            <MUICancelButton
                                                title='Next'
                                                startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalDataCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                onClick={() => handleChangePage(null, page + 1)}
                                                disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                                sx={{ height: '36px' }}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </Table>
                    </Paper>

                    {/* More filters Dialog */}
                    <Dialog
                        open={open}
                        scroll="paper"
                        maxWidth='md'
                        className="sidePopup"
                    >
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 550 }}>
                            Filters
                            <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={() => setOpen(false)} />
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} gap={2}>
                                        <Grid2 item>
                                            <InputLabel className="inputlabels">Client Name</InputLabel>
                                            <TextField
                                                className="textfields"
                                                value={client || ""}
                                                onChange={handleClientName}
                                                placeholder='Search By Client Name'
                                            />
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="inputlabels">Phone</InputLabel>
                                            <TextField
                                                className="textfields"
                                                placeholder='Search By Phone'
                                                value={filterByPhone}
                                                onChange={handleFilterByPhone}
                                            />
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="inputlabels">Email</InputLabel>
                                            <TextField
                                                className="textfields"
                                                placeholder='Search By Email'
                                                value={filterByEmail}
                                                onChange={handleFilterByEmail}
                                            />
                                        </Grid2>
                                    </Grid2>

                                    <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '15px' }} gap={2}>
                                        <Grid2 item>
                                            <InputLabel className="inputlabels">Address</InputLabel>
                                            <TextField
                                                className="textfields"
                                                placeholder='Search By Address'
                                                value={filterByAddress}
                                                onChange={handleFilterByAddress}
                                            />
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="inputlabels">City</InputLabel>
                                            <TextField
                                                className="textfields"
                                                placeholder='Search By City'
                                                value={filterByCity}
                                                onChange={handleFilterByCity}
                                            />
                                        </Grid2>


                                        <Grid2 item>
                                            <InputLabel className="inputlabels">Status</InputLabel>
                                            <Select
                                                className="dropdown"
                                                placeholder="Select Status"
                                                value={selectedStatus || ""}
                                                onChange={handleStatusChange}
                                                displayEmpty
                                                IconComponent={KeyboardArrowDownIcon}
                                                renderValue={(selected) =>
                                                    !selected
                                                        ? <p className="menuItemsPlaceholder">Select Status</p>
                                                        : statusOptions?.find((name) => name?.id === selected)?.label || ''
                                                }
                                            >
                                                <MenuItem value="" disabled> <span className="menuItemsPlaceholder"> Select Status</span></MenuItem>
                                                {statusOptions?.map((option) => (
                                                    <MenuItem className="menuitems" key={option?.id} value={option?.id}>
                                                        {option?.label}
                                                        {option?.id === selectedStatus && (
                                                            <DoneIcon className="doneIcon" />
                                                        )}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="inputlabels">From Date</InputLabel>
                                            <MuiDatePicker
                                                slotProps={{
                                                    textField:
                                                    {
                                                        placeholder: 'Select From Date',
                                                    },
                                                }}
                                                value={filterByCreatedDate}
                                                onChange={handleFilterByCreatedDate}
                                            />
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="inputlabels">To Date</InputLabel>
                                            <MuiDatePicker
                                                slotProps={{
                                                    textField:
                                                    {
                                                        size: 'small',
                                                        placeholder: 'Select To Date',
                                                        InputProps: {
                                                            sx: { borderRadius: '10px', height: '35px' },
                                                        },
                                                    },
                                                }}
                                                sx={{
                                                    "& .MuiSvgIcon-root": {
                                                        fontSize: '20px'
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                    width: '100%'
                                                }}
                                                value={filterByToDate}
                                                onChange={handleFilterByToDate}
                                                format='DD-MM-YYYY'
                                                minDate={getNextDay(filterByCreatedDate) || null}
                                                maxDate={dayjs()}
                                                disabled={!filterByCreatedDate}
                                            />
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <MUICancelButton title='Cancel' sx={{ width: '42%' }} onClick={() => setOpen(false)} />
                                <MUIButton title='Apply' sx={{ width: '42%' }}
                                    onClick={letsFilterDatas}
                                />
                            </Grid2>
                        </DialogActions>
                    </Dialog>
                    {/* <Table>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    className="tablepagination"
                                    count={totalDataCount || 0}
                                    onPageChange={handleChangePage}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table> */}

                </Grid2>
            </Grid2>

            <Grid2>
                <Dialog
                    open={openReject}
                    scroll="paper"
                    maxWidth="sm"
                    onClose={() => setOpenReject(false)}
                    sx={{
                        "& .MuiDialog-paper": {
                            minWidth: '40vw',
                            minHeight: 'auto'
                        }
                    }}
                >
                    {/* Dialog Title */}
                    <DialogTitle dividers sx={{ fontWeight: 'bold', alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                        Rejection
                        <CloseIcon sx={{ cursor: 'pointer', color: '#A4A7AE' }} onClick={handleCloseReject} />
                    </DialogTitle>

                    {/* Dialog Content */}
                    <DialogContent>
                        <InputLabel className="inputlabels">Reason for Rejection<span style={{ color: 'red' }}>*</span></InputLabel>
                        <textarea
                            value={reason}
                            onChange={handleReason}
                            placeholder="Enter Reason for Rejection"
                            className="textareas"
                            style={{
                                width: '100%',
                                height: '130px'
                            }}
                        />
                        {reason === '' && (
                            <span style={{ color: "red", fontSize: '0.85rem' }}>{isReason}</span>
                        )}
                    </DialogContent>

                    {/* Dialog Actions (Footer) */}
                    <DialogActions sx={{ justifyContent: 'flex-end', paddingBottom: '16px' }}>
                        <MUIButton
                            title='Reject'
                            onClick={handleRejected}
                            sx={{
                                backgroundColor: '#FFF4ED',
                                border: '1px solid #FFD6AE',
                                color: '#D92D20'
                            }}
                        />
                    </DialogActions>
                </Dialog>
            </Grid2>

            <Grid2>
                <Dialog
                    open={openMailDialog}
                    onClose={handleMailDialogClose}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        "& .MuiDialog-paper": {
                            minWidth: '50vw',
                            minHeight: 'auto'
                        },
                    }}
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 600, fontSize: '18px' }}>
                        {`Email to ${BAname} `}
                        <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleMailDialogClose} />
                    </DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText>
                            <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Grid2 item sx={{ display: 'flex', flexGrow: 1, alignItems: 'center' }}>
                                    <InputLabel className="inputlabels" sx={{ width: '13%', fontWeight: 'bold' }}>To:</InputLabel>
                                    <TextField
                                        value={mailTo}
                                        onChange={handleMailToChange}
                                        size="small"
                                        className="textfields"
                                        placeholder="Enter Mail Id"
                                        sx={{ width: '55% !important' }}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ display: 'flex', flexGrow: 1, alignItems: 'center', marginTop: '30px' }}>
                                    <InputLabel className="inputlabels" sx={{ width: '13%', fontWeight: 'bold' }}>Subject:</InputLabel>
                                    <TextField
                                        value={mailSubject}
                                        onChange={handleMailSubjectChange}
                                        size="small"
                                        className="textfields"
                                        placeholder="Enter Subject"
                                        sx={{ width: '55% !important' }}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ marginTop: '30px' }}>
                                    <ReactQuill
                                        value={mailBodycontent}
                                        onChange={handleBodyContentChange}
                                        formats={formats}
                                        modules={toolBarOptions}
                                        placeholder="Start typing here..."
                                        style={{ color: '#000000' }}
                                    />
                                </Grid2>
                            </Grid2>

                            <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                                <MUIButton title='Send' sx={{ backgroundColor: "#7F56D9" }} onClick={handleSendEmailToRecruiter} disabled={!mailSubject || !mailBodycontent.replace(/<[^>]*>?/gm, '').trim()} />
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </Grid2>
        </Box>
    )
}

export default ClientReferrals